/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as cameraV1 from "./keyapis_vc_camera_v1.pb"

/**
 * Спецификация для работы с видеоданными камер
 */

/**
 * Сервис управления видеоданными камер
 */
export class CameraVideoDataServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения количества камер.
   * Для master это камеры, привязанные к пользователю, используем поля токена vc_user_id, user_id, company_id.
   * Для owner, employee это камеры, привязанные к компании, используем поле токена company_id.
   * Для admin, service, bti, ltp_first это камеры, привязанные к компании, используем поле scope.company_id.
   * Для admin, service, bti, ltp_first это камеры, привязанные к пользователю, используем поле scope.user_id.
   * Метод доступен для: admin, service, bti, ltp_first, master, owner, employee
   */
  GetCameraVideoDataCount = (req?: GetCameraVideoDataCountRequestDto, init?: RequestInit): Promise<GetCameraVideoDataCountResponseDto> => {
    return fm.request<GetCameraVideoDataCountRequestDto, GetCameraVideoDataCountResponseDto>(`${this.host}/vc/api/v1/camera_video_data/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка камер.
   * Для master это камеры, привязанные к пользователю, используем поля токена vc_user_id, user_id, company_id.
   * Для owner, employee это камеры, привязанные к компании, используем поле токена company_id.
   * Для admin, service, bti, ltp_first это камеры, привязанные к компании, используем поле scope.company_id.
   * Для admin, service, bti, ltp_first это камеры, привязанные к пользователю, используем поле scope.user_id.
   * Метод доступен для: admin, service, bti, ltp_first, master, owner, employee
   */
  GetCameraVideoDataList = (req?: GetCameraVideoDataListRequestDto, init?: RequestInit): Promise<GetCameraVideoDataListResponseDto> => {
    return fm.request<GetCameraVideoDataListRequestDto, GetCameraVideoDataListResponseDto>(`${this.host}/vc/api/v1/camera_video_data/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum CameraVideoDataPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type CameraVideoDataPagingDirectionTypeResponseEnum = keyof typeof CameraVideoDataPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type CameraVideoDataPagingDirectionTypeRequestEnum = Exclude<CameraVideoDataPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum CameraVideoDataPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По дате создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type CameraVideoDataPagingOrderByTypeResponseEnum = keyof typeof CameraVideoDataPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type CameraVideoDataPagingOrderByTypeRequestEnum = Exclude<CameraVideoDataPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Камера
 */
export type CameraVideoDataRequestDto = {
  /**
   * Идентификатор камеры в системе Видеокомфорт.
   * Тип: Guid
   */
  uid: string
  /**
   * Категория камеры
   */
  category?: CameraVideoDataCategoryRequestDto | null
  /**
   * Наименование камеры
   */
  title: string
  /**
   * Серийный номер камеры
   */
  serialNumber: string
  /**
   * IP камеры
   */
  ip: string
  /**
   * Адрес видео-потока (https соединение)
   */
  streamerUrl: string
  /**
   * MAC-адрес камеры
   */
  mac: string
  /**
   * Модель камеры
   */
  model?: string
  /**
   * Производитель камеры
   */
  vendor?: string
  /**
   * Статус камеры
   */
  status: CameraVideoDataStatusRequestDto
  /**
   * URL скриншотов разных размеров в JPG-формате
   */
  screenshotUrlTemplate: string
  /**
   * Шаблон для “точных” скриншотов. Выдаёт скриншоты всех размеров
   */
  screenshotPreciseUrlTemplate: string
  /**
   * U-Токен, кука, которая выдается Умному Дому
   */
  userToken: string
  /**
   * Токен для воспроизведения видео с камеры
   */
  streamerToken: string
  /**
   * Токен для получения контента с cdn (например, файлов изображений)
   */
  screenshotToken: string
  /**
   * Глубина хранения видео в минутах
   */
  archiveLength?: number
  /**
   * Координаты месторасположения
   */
  location?: CameraVideoDataLocationRequestDto | null
  /**
   * Смещение таймзоны в минутах.
   * # Диапазон: -720..840
   */
  utcOffset?: number
}
/**
 * Камера
 */
export type CameraVideoDataResponseDto = {
  /**
   * Идентификатор камеры в системе Видеокомфорт.
   * Тип: Guid
   */
  uid: string
  /**
   * Категория камеры
   */
  category: CameraVideoDataCategoryResponseDto | null
  /**
   * Наименование камеры
   */
  title: string
  /**
   * Серийный номер камеры
   */
  serialNumber: string
  /**
   * IP камеры
   */
  ip: string
  /**
   * Адрес видео-потока (https соединение)
   */
  streamerUrl: string
  /**
   * MAC-адрес камеры
   */
  mac: string
  /**
   * Модель камеры
   */
  model: string
  /**
   * Производитель камеры
   */
  vendor: string
  /**
   * Статус камеры
   */
  status: CameraVideoDataStatusResponseDto
  /**
   * URL скриншотов разных размеров в JPG-формате
   */
  screenshotUrlTemplate: string
  /**
   * Шаблон для “точных” скриншотов. Выдаёт скриншоты всех размеров
   */
  screenshotPreciseUrlTemplate: string
  /**
   * U-Токен, кука, которая выдается Умному Дому
   */
  userToken: string
  /**
   * Токен для воспроизведения видео с камеры
   */
  streamerToken: string
  /**
   * Токен для получения контента с cdn (например, файлов изображений)
   */
  screenshotToken: string
  /**
   * Глубина хранения видео в минутах
   */
  archiveLength: number
  /**
   * Координаты месторасположения
   */
  location: CameraVideoDataLocationResponseDto | null
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата обновления
   */
  readonly updatedAt: string | null
  /**
   * Смещение таймзоны в минутах.
   * # Диапазон: -720..840
   */
  utcOffset: number
}
/**
 * Категория камеры
 */
export type CameraVideoDataCategoryRequestDto = {
  /**
   * Идентификатор группы
   */
  id: number
  /**
   * Тип группы
   */
  type: string
  /**
   * Имя группы
   */
  title: string
}
/**
 * Категория камеры
 */
export type CameraVideoDataCategoryResponseDto = {
  /**
   * Идентификатор группы
   */
  id: number
  /**
   * Тип группы
   */
  type: string
  /**
   * Имя группы
   */
  title: string
}
/**
 * Координаты месторасположения
 */
export type CameraVideoDataLocationRequestDto = {
  /**
   * Широта
   */
  lat: number
  /**
   * Долгота
   */
  lng: number
}
/**
 * Координаты месторасположения
 */
export type CameraVideoDataLocationResponseDto = {
  /**
   * Широта
   */
  lat: number
  /**
   * Долгота
   */
  lng: number
}
/**
 * Статус камеры
 */
export type CameraVideoDataStatusRequestDto = {
  /**
   * Идентификатор статуса
   */
  id: number
  /**
   * online/offline
   */
  type: string
  /**
   * Доступна/Не доступна
   */
  title: string
}
/**
 * Статус камеры
 */
export type CameraVideoDataStatusResponseDto = {
  /**
   * Идентификатор статуса
   */
  id: number
  /**
   * online/offline
   */
  type: string
  /**
   * Доступна/Не доступна
   */
  title: string
}
/**
 * Фильтр камер
 */
export type CameraVideoDataFilterRequestDto = {
  /**
   * Идентификатор камеры в системе Видеокомфорт.
   * Тип: Guid
   */
  uids?: string[]
  /**
   * Наименование камеры
   */
  title?: string[]
  /**
   * MAC-адрес камеры
   */
  mac?: string[]
  /**
   * IP камеры
   */
  ip?: string[]
  /**
   * Серийный номер камеры
   */
  serialNumber?: string[]
  /**
   * Категория камеры
   */
  category?: string[]
}
/**
 * Фильтр камер
 */
export type CameraVideoDataFilterResponseDto = {
  /**
   * Идентификатор камеры в системе Видеокомфорт.
   * Тип: Guid
   */
  uids: string[]
  /**
   * Наименование камеры
   */
  title: string[]
  /**
   * MAC-адрес камеры
   */
  mac: string[]
  /**
   * IP камеры
   */
  ip: string[]
  /**
   * Серийный номер камеры
   */
  serialNumber: string[]
  /**
   * Категория камеры
   */
  category: string[]
}
/**
 * Постраничный вывод
 */
export type CameraVideoDataPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * По умолчанию: UID
   */
  orderByType?: CameraVideoDataPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: CameraVideoDataPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type CameraVideoDataPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * По умолчанию: UID
   */
  orderByType: CameraVideoDataPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: CameraVideoDataPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ограничение выборки камер
 */
export type CameraVideoDataScopeRequestDto = {
}
/**
 * scope
 */
& fm.OptionalOneOf<{
  /**
   * Идентификатор компании
   */
  readonly companyId: string
  /**
   * Идентификатор пользователя
   */
  readonly userId: number
}>
/**
 * Ограничение выборки камер
 */
export type CameraVideoDataScopeResponseDto = {
}
/**
 * scope
 */
& fm.OneOf<{
  /**
   * Идентификатор компании
   */
  readonly companyId: string
  /**
   * Идентификатор пользователя
   */
  readonly userId: number
}>
/**
 * Запрос на получение количества камер
 */
export type GetCameraVideoDataCountRequestDto = {
  /**
   * Ограничение выборки
   */
  scope?: CameraVideoDataScopeRequestDto | null
  /**
   * Фильтр
   */
  filter?: CameraVideoDataFilterRequestDto | null
}
/**
 * Ответ на получение количества камер
 */
export type GetCameraVideoDataCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetCameraVideoDataCountResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraVideoDataCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraVideoDataCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка камер
 */
export type GetCameraVideoDataListRequestDto = {
  /**
   * Ограничение выборки
   */
  scope?: CameraVideoDataScopeRequestDto | null
  /**
   * Фильтр
   */
  filter?: CameraVideoDataFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: CameraVideoDataPagingRequestDto
}>
/**
 * Ответ на получение списка камер
 */
export type GetCameraVideoDataListResponseDto = {
  /**
   * Камера
   */
  data: CameraVideoDataResponseDto[]
  /**
   * Ошибка
   */
  error: GetCameraVideoDataListResponseErrorDto | null
}
/**
 * Ошибка запроса
 */
export type GetCameraVideoDataListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraVideoDataListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Камера
   */
  "CameraVideoData": {
    "kind": "class",
    "text": "Камера",
    "fields": {
      /**
       * Идентификатор камеры в системе Видеокомфорт.
       * Тип: Guid
       */
      "uid": {
        "type": "string",
        "text": "Идентификатор камеры в системе Видеокомфорт.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Категория камеры
       */
      "category": {
        "type": "CameraVideoData.Category",
        "text": "Категория камеры",
      },
      /**
       * Наименование камеры
       */
      "title": {
        "type": "string",
        "text": "Наименование камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Серийный номер камеры
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * IP камеры
       */
      "ip": {
        "type": "string",
        "text": "IP камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Адрес видео-потока (https соединение)
       */
      "streamerUrl": {
        "type": "string",
        "text": "Адрес видео-потока (https соединение)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * MAC-адрес камеры
       */
      "mac": {
        "type": "string",
        "text": "MAC-адрес камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель камеры
       */
      "model": {
        "type": "string",
        "text": "Модель камеры",
      },
      /**
       * Производитель камеры
       */
      "vendor": {
        "type": "string",
        "text": "Производитель камеры",
      },
      /**
       * Статус камеры
       */
      "status": {
        "type": "CameraVideoData.Status",
        "text": "Статус камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * URL скриншотов разных размеров в JPG-формате
       */
      "screenshotUrlTemplate": {
        "type": "string",
        "text": "URL скриншотов разных размеров в JPG-формате",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Шаблон для “точных” скриншотов. Выдаёт скриншоты всех размеров
       */
      "screenshotPreciseUrlTemplate": {
        "type": "string",
        "text": "Шаблон для “точных” скриншотов. Выдаёт скриншоты всех размеров",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * U-Токен, кука, которая выдается Умному Дому
       */
      "userToken": {
        "type": "string",
        "text": "U-Токен, кука, которая выдается Умному Дому",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Токен для воспроизведения видео с камеры
       */
      "streamerToken": {
        "type": "string",
        "text": "Токен для воспроизведения видео с камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Токен для получения контента с cdn (например, файлов изображений)
       */
      "screenshotToken": {
        "type": "string",
        "text": "Токен для получения контента с cdn (например, файлов изображений)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Глубина хранения видео в минутах
       */
      "archiveLength": {
        "type": "int32",
        "text": "Глубина хранения видео в минутах",
      },
      /**
       * Координаты месторасположения
       */
      "location": {
        "type": "CameraVideoData.Location",
        "text": "Координаты месторасположения",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата обновления
       */
      "updatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата обновления",
      },
      /**
       * Смещение таймзоны в минутах.
       * # Диапазон: -720..840
       */
      "utcOffset": {
        "type": "int32",
        "text": "Смещение таймзоны в минутах.\n# Диапазон: -720..840",
        "rules": {
          "min": {
            "value": -720,
            "message": "Значение не входит в допустимый диапазон. Минимум: -720"
          },
          "max": {
            "value": 840,
            "message": "Значение не входит в допустимый диапазон. Максимум: 840"
          },
        }
      },
    },
  },
  /**
   * Категория камеры
   */
  "CameraVideoData.Category": {
    "kind": "class",
    "text": "Категория камеры",
    "fields": {
      /**
       * Идентификатор группы
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип группы
       */
      "type": {
        "type": "string",
        "text": "Тип группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя группы
       */
      "title": {
        "type": "string",
        "text": "Имя группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Координаты месторасположения
   */
  "CameraVideoData.Location": {
    "kind": "class",
    "text": "Координаты месторасположения",
    "fields": {
      /**
       * Широта
       */
      "lat": {
        "type": "double",
        "text": "Широта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Долгота
       */
      "lng": {
        "type": "double",
        "text": "Долгота",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Статус камеры
   */
  "CameraVideoData.Status": {
    "kind": "class",
    "text": "Статус камеры",
    "fields": {
      /**
       * Идентификатор статуса
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор статуса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * online/offline
       */
      "type": {
        "type": "string",
        "text": "online/offline",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Доступна/Не доступна
       */
      "title": {
        "type": "string",
        "text": "Доступна/Не доступна",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр камер
   */
  "CameraVideoDataFilter": {
    "kind": "class",
    "text": "Фильтр камер",
    "fields": {
      /**
       * Идентификатор камеры в системе Видеокомфорт.
       * Тип: Guid
       */
      "uids": {
        "type": "string",
        "text": "Идентификатор камеры в системе Видеокомфорт.\nТип: Guid",
      },
      /**
       * Наименование камеры
       */
      "title": {
        "type": "string",
        "text": "Наименование камеры",
      },
      /**
       * MAC-адрес камеры
       */
      "mac": {
        "type": "string",
        "text": "MAC-адрес камеры",
      },
      /**
       * IP камеры
       */
      "ip": {
        "type": "string",
        "text": "IP камеры",
      },
      /**
       * Серийный номер камеры
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер камеры",
      },
      /**
       * Категория камеры
       */
      "category": {
        "type": "string",
        "text": "Категория камеры",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "CameraVideoDataPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * По умолчанию: UID
       */
      "orderByType": {
        "type": "CameraVideoDataPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\nПо умолчанию: UID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "CameraVideoDataPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ограничение выборки камер
   */
  "CameraVideoDataScope": {
    "kind": "class",
    "text": "Ограничение выборки камер",
    "fields": {
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "int64",
        "text": "Идентификатор компании",
      },
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
    },
  },
  /**
   * Запрос на получение количества камер
   */
  "GetCameraVideoDataCountRequest": {
    "kind": "class",
    "text": "Запрос на получение количества камер",
    "fields": {
      /**
       * Ограничение выборки
       */
      "scope": {
        "type": "CameraVideoDataScope",
        "text": "Ограничение выборки",
      },
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraVideoDataFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на получение количества камер
   */
  "GetCameraVideoDataCountResponse": {
    "kind": "class",
    "text": "Ответ на получение количества камер",
    "fields": {
      /**
       * Всего количество
       */
      "data": {
        "type": "int32",
        "text": "Всего количество",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraVideoDataCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraVideoDataCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка камер
   */
  "GetCameraVideoDataListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка камер",
    "fields": {
      /**
       * Ограничение выборки
       */
      "scope": {
        "type": "CameraVideoDataScope",
        "text": "Ограничение выборки",
      },
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraVideoDataFilter",
        "text": "Фильтр",
      },
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "CameraVideoDataPaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка камер
   */
  "GetCameraVideoDataListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка камер",
    "fields": {
      /**
       * Камера
       */
      "data": {
        "type": "CameraVideoData",
        "text": "Камера",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraVideoDataListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraVideoDataListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "CameraVideoDataPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "CameraVideoDataPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По дате создания
       */
      "CREATED_AT": {
        "i": 1,
        "text": "По дате создания",
      },
    },
  },
}